/* US utility pages: close the native facets drawer after applying filters.
   Use Dawn's existing method so focus and body scroll are restored together. */
document.addEventListener('click', (event) => {
  const button = event.target.closest('.mobile-facets__footer button.button--primary');
  if (!button || !document.body.classList.contains('us-utility')) return;
  const drawer = button.closest('menu-drawer');
  if (typeof drawer?.closeMenuDrawer !== 'function') return;
  event.preventDefault();
  event.stopImmediatePropagation();
  drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
}, true);
